<template>
  <div>
    <el-menu
        :default-active="path"
        router
        mode="horizontal"
        background-color="#617173"
        text-color="#EEEADB"
        active-text-color="white"
        @select="handleSelect"
        class="menu-container"
    >
      <el-sub-menu index="1" style="text-align:center" @click="$router.push('/mainPage')">
        <template #title>首頁</template>
        <el-menu-item index="/mainPage">最新消息</el-menu-item>
        <el-menu-item index="/mainPage">過往活動</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="2" style="text-align:center" @click="$router.push('/aboutUs')">
        <template #title>關於我們</template>
        <el-menu-item index="/aboutUs">使命與背景</el-menu-item>
        <el-menu-item index="/memberShip">成員介紹</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="3" style="text-align:center" @click="$router.push('/service1')">
        <template #title>服務</template>
        <el-menu-item index="/service1">中醫藥主題校本服務</el-menu-item>
        <el-menu-item index="/service2">青年中醫師專業賦能計畫</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="4" style="text-align:center" @click="$router.push('/activity1')">
        <template #title>課程活動</template>
        <el-menu-item index="/activity1">中醫師學分講座</el-menu-item>
        <el-menu-item index="/activity2">本科生學術講座</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="5" style="text-align:center" @click="$router.push('/resource1')">
        <template #title>資源</template>
        <el-menu-item index="/resource1">執業考試資源</el-menu-item>
        <el-menu-item index="/resource2">書籍推薦</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="6" style="text-align:center" @click="$router.push('/paper1')">
        <template #title>專題文章</template>
        <el-menu-item index="/paper1">中醫養生年輕化</el-menu-item>
        <el-menu-item index="/paper2">人工智慧（AI）與中醫診所現代化</el-menu-item>
      </el-sub-menu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Aside2"
}
</script>

<style scoped>
.menu-container {
  display: flex;
  justify-content: space-evenly; /* 改为均匀分布 */
  flex-wrap: wrap; /* 允许菜单项换行 */
  width: 100%;
  overflow: visible;/* 保证不会出现菜单项出现省略号*/
}
.el-sub-menu {
  flex: 0 1 auto; /* 防止 flex 项被压缩，允许它们保持原始大小 */
  text-align: center;
  white-space: nowrap; /* 防止菜单项文字换行 */
  padding: 0 10px; /* 给每个子菜单项添加左右间距 */
}
</style>
